import { ButtonV2 } from "../../components/buttonv2";
import { formatOrderAmount } from "../../helpers/orderAmounts";

export const OrderAmounts = ({ data, printTicket, printInvoice }) => {
  const amounts = data?.amounts;
  const rows = [
    ["Subtotal con impuestos", amounts?.subtotalWithTax],
    ["Descuento con impuestos", amounts?.discountsWithTax],
    ["Base imponible", amounts?.base],
    ["Impuestos", amounts?.tax],
    ["Gastos de envío", amounts?.shipping],
    ["Total", amounts?.total],
  ];
  return (
    <div className="invoiceResume">
      <div className="invoiceResumeHeader">
        <div>
          <div className="invoiceResumeHeaderTitle">No. Factura</div>
          <div className="invoiceResumeHeaderValue">{data?.Invoice?.number || (data?.Invoice ? "Creada" : "Sin factura")}</div>
        </div>
        <div>
          <div className="invoiceResumeHeaderTitle">Canal de venta</div>
          <div className="invoiceResumeHeaderValue">{data?.SalesChannel?.name}</div>
        </div>
      </div>
      <div className="invoiceResumeBody">
        {rows.map(([label, value]) => (
          <div className="invoiceResumeItem" key={label}>
            <div>{label}</div><div />
            <div className="invoiceResumeValue">{formatOrderAmount(value)}</div>
          </div>
        ))}
      </div>
      <div className="invoiceResumeActions">
        <ButtonV2 text="Imprimir cocina" action={printTicket} />
        {data?.Invoice && <ButtonV2 text="Imprimir factura" action={printInvoice} />}
      </div>
    </div>
  );
};

export const OrderAmountProducts = ({ data }) => (
  <div className="orderProducts">
    {(data?.products || []).map((product, index) => (
      <div className="orderProductItem" key={product.orderProductId || product.productId || index}>
        <div className="orderProductInfo">
          <div className="orderProductName">{product.shortName || product.name}</div>
          <div>Cantidad: {product.quantity}</div>
          {product.note && <div>{product.note}</div>}
        </div>
        <div>
          <div>Precio con impuestos: {formatOrderAmount(product.unitPriceWithTax)}</div>
          <div>Subtotal del producto con impuestos: {formatOrderAmount(product.lineTotalWithTax)}</div>
        </div>
      </div>
    ))}
  </div>
);
